const composeUrl = (route: string, query: { [key: string]: string } = {}) => {
  const queryParameters = new URLSearchParams();

  const pathname = Object.keys(query).reduce((composed, parameterKey) => {
    const parameterSignature = `[${parameterKey}]`;

    if (!query[parameterKey]) {
      return composed;
    }

    if (composed.includes(parameterSignature)) {
      return composed.replace(parameterSignature, query[parameterKey]);
    }
    queryParameters.set(parameterKey, query[parameterKey]);

    return composed;
  }, route);

  if (queryParameters.toString().length > 0) {
    return `${pathname}?${queryParameters.toString()}`;
  }

  return pathname;
};

export default composeUrl;
